/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMemberFamilyContactRequest
 */
export interface CreateMemberFamilyContactRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMemberFamilyContactRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemberFamilyContactRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemberFamilyContactRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemberFamilyContactRequest
     */
    cellPhone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemberFamilyContactRequest
     */
    addressLine1: string;
}

/**
 * Check if a given object implements the CreateMemberFamilyContactRequest interface.
 */
export function instanceOfCreateMemberFamilyContactRequest(value: object): value is CreateMemberFamilyContactRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    return true;
}

export function CreateMemberFamilyContactRequestFromJSON(json: any): CreateMemberFamilyContactRequest {
    return CreateMemberFamilyContactRequestFromJSONTyped(json, false);
}

export function CreateMemberFamilyContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMemberFamilyContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'cellPhone': json['cellPhone'],
        'addressLine1': json['addressLine1'],
    };
}

export function CreateMemberFamilyContactRequestToJSON(json: any): CreateMemberFamilyContactRequest {
    return CreateMemberFamilyContactRequestToJSONTyped(json, false);
}

export function CreateMemberFamilyContactRequestToJSONTyped(value?: CreateMemberFamilyContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'cellPhone': value['cellPhone'],
        'addressLine1': value['addressLine1'],
    };
}

